import { render, staticRenderFns } from "./ClienteListFilters.vue?vue&type=template&id=1c958bc0&"
import script from "./ClienteListFilters.vue?vue&type=script&lang=js&"
export * from "./ClienteListFilters.vue?vue&type=script&lang=js&"
import style0 from "./ClienteListFilters.vue?vue&type=style&index=0&id=1c958bc0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports